<template>
  <!-- 查看品牌商品 -->
  <div class="prefectureGoods">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="delDettle()"
          :disabled="selectedList.length == 0"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加商品</el-button
        >
      </template>
    </page-header>
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="article_id"
        label="商品编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort_id"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.sort_id"
            @blur="changeSort(scope.row)"
            type="number"
            min="1"
            max="100000"
            placeholder="请输入排序值"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="sub_title"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="stock_quantity"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="approval_number"
        label="国药准字"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="添加时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 绑定商品dialog -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <!-- 搜索框 -->
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称/品牌"
            v-model="searchForm2.name"
          ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="seach"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-scrollbar
        style="height: 280px; padding-top: 20px; box-sizing: border-box"
      >
        <el-table
          :data="goodsList"
          ref="multipleTable"
          stripe
          border
          @selection-change="selectionChange2"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column type="selection" align="center" width="55">
          </el-table-column>
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="scope">
              <span>{{ (currPage2 - 1) * pageSize2 + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="goodscode"
            label="商品编号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sub_title"
            label="名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="drug_spec"
            label="规格"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="min_package"
            label="中包装"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="big_package"
            label="件数量"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="drug_factory"
            label="生产厂家"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="stock_quantity"
            label="库存"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </el-scrollbar>
      <!-- 分页 -->
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="clearForm">取 消</el-button>
        <el-button
          type="primary"
          :disabled="selectedList2.length == 0"
          @click="submitForm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "prefectureGoods",
  data() {
    return {
      id: "",
      entId: "",
      /**表格数据 */
      //商品编号	排序	商品名称	商品规格	建议零售价	库存	国药准字	生产厂家	添加时间
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [] /**存放选中的数据 */,
      dialogVisible: false /**商品列表dialog */,

      //商品编号	名称	规格	中包装	件装量	生产厂家	库存
      goodsList: [] /**商品列表 */,
      selectedList2: [] /**存放选中的商品数据 */,
      /**分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,
      /**搜索表单 */
      searchForm2: {
        name: "",
      },
    };
  },
  components: {},
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.entId = prams.entId;
      this.getTableData();
      this.getGoodsList();
    }
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 修改商品排序值
    changeSort(row) {
      let data = {
        billno: this.id,
        sortId: row.sort_id,
        articleId: row.article_id,
        type: "EditBrandGoodsSort",
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$refs.multipleTable.clearSelection();
            // this.dialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取表格数据 */
    getTableData() {
      let data = {
        billno: this.id,
        strWhere: "",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        type: "Pc_GetBrandProduct",
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 删除数据
    delDettle() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.article_id);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "PC_DelBrandPro",
            strWhere: idList,
            billno: this.id,
          };
          let proc = "Proc_Admin_Brand"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.getTableData();
                this.$message({
                  message: res.message,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 搜索商品品牌
    seach() {
      this.getGoodsList();
    },
    /**获取商品数据 */
    getGoodsList() {
      let data = {
        type: "GoodsListPP",
        strWhere: this.searchForm2.name,
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        xentId: this.entId,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsList = res.content;
            this.allPage2 = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },
    /**点击添加商品 */
    handleAdd() {
      this.dialogVisible = true;
    },
    /**点击确定绑定 */
    submitForm() {
      let idList = [];
      this.selectedList2.forEach((i) => {
        idList.push(i.keyid);
      });
      idList = idList.join();
      let data = {
        type: "SaveBrandGoodList",
        articleList: idList,
        fabh: this.id,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$refs.multipleTable.clearSelection();
            // this.dialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**取消绑定 */
    clearForm() {
      this.dialogVisible = false;
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**selection change触发事件 */
    selectionChange2(section) {
      //存放选中的表格数据
      this.selectedList2 = section;
    },
  },
};
</script>

<style scoped>
.prefectureGoods {
  width: 100%;
  height: 100%;
}
</style>
